import { render, staticRenderFns } from "./Advertising.vue?vue&type=template&id=4bb85cae&scoped=true"
import script from "./Advertising.vue?vue&type=script&lang=js"
export * from "./Advertising.vue?vue&type=script&lang=js"
import style0 from "./Advertising.vue?vue&type=style&index=0&id=4bb85cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb85cae",
  null
  
)

export default component.exports